import React from 'react';
import logoMark from '../../assets/images/sanspath-logo-mark.png';
import logoText from '../../assets/images/sanspath-logo-text.png';

const SanspathLogo = ({ variant = 'text', className = '', imageClassName = '' }) => {
  const source = variant === 'mark' ? logoMark : logoText;
  const alt = variant === 'mark' ? 'Sanspath logo mark' : 'Sanspath';
  const frameClassName = variant === 'mark' ? 'h-12 w-12' : 'h-12 w-44';
  const imageSizeClassName = variant === 'mark' ? 'h-24' : 'h-28';

  return (
    <div className={`flex items-center ${className}`}>
      <span className={`relative block overflow-hidden ${frameClassName} ${imageClassName}`}>
        <img
          src={source}
          alt={alt}
          className={`absolute left-1/2 top-1/2 max-w-none -translate-x-1/2 -translate-y-1/2 object-contain ${imageSizeClassName}`}
        />
      </span>
    </div>
  );
};

export default SanspathLogo;
